import React from 'react';
import ticketScannedImg from '../../../../assets/images/eTicket/ticketScanned.png';
import * as css from './QrZoomScanEffects.css';

interface QrZoomScanEffectsProps {
    isScanning: boolean;
}

function QrZoomScanEffects({isScanning}: QrZoomScanEffectsProps): React.ReactElement | null {
    if(!isScanning) {
        return null;
    }

    return (
        <>
            <css.scanline aria-hidden />
            <css.fire $image={ticketScannedImg} aria-hidden />
        </>
    );
}

export default QrZoomScanEffects;
